const style = {
  select: {
    padding: `5px 15px`,
    width: `100%`,
    height: `40px`,
    overflow: `hidden`,
    background: `#fff`,
    border: `1px solid #ddd`,
    borderRadius: 0,
    '-webkit-appearance': `none`,
    fontSize: `14px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/Sidebar/style/selector.js